import { createSlice } from "@reduxjs/toolkit";

export const sliceLivefeed = createSlice({
  name: "GroupData",
  initialState: {
    data: {},
  },
  reducers: {
    fetcheddata: (state, { payload }) => {
      state.data = payload.data;
    },
  },
});

export const { fetcheddata } = sliceLivefeed.actions;

export const SetGroupData = (data) => async (dispatch) => {
  dispatch(fetcheddata({ data }));
};

export default sliceLivefeed.reducer;
